<template>
  <div app-header :class="[theme, roll, scrolled]">
    <header :style="bgColor ? `background-color:#${bgColor}` : ''">
      <div class="inner-wrap">
        <locale-link to="/" class="logo"><h1 class="ir">NEWTYPE</h1></locale-link>
        <div class="aside">
          <a class="search" @click="onSearch"></a>
          <a class="menu" @click="onMenu"></a>
        </div>
      </div>
    </header>
    <aside class="drawer" :class="{ on: menuOpen }">
      <div class="inner-wrap">
        <a class="close" @click="clickClose"></a>
        <div class="drawer-backdrop"></div>
        <div class="drawer-holder">
          <div class="space-wrap">
            <div class="logo">newtype imageworks</div>
            <nav class="drawer-menu">
              <locale-link to="/works">works</locale-link>
              <locale-link to="/works/article/about">about</locale-link>
              <locale-link to="/works/article/contact">contact</locale-link>
              <locale-link to="/works/article/career">career</locale-link>
              <!--          <a href="https://newtype.careers.team/" target="_blank">career</a>-->
            </nav>
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      menuOpen: false,
      searchOpen: false,
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    bgColor() {
      return this.$store.state.bgColor;
    },
    roll() {
      return this.$store.state.browser.scrollDirection === 'down' && 'roll';
    },
    scrolled() {
      return this.$store.state.browser.scrolled;
    },
    isBack() {
      return this.$route.path.includes('/works/article/');
    },
  },
  watch: {
    $route: 'reset',
  },
  mounted() {
    this.$root.$on('search', this.onSearch);
  },
  beforeDestroy() {
    this.$root.$off('search', this.onSearch);
  },
  methods: {
    historyBack() {
      this.$store.state.browser.isFirst ? this.localeLink('/') : this.$router.go(-1);
    },
    reset() {
      this.menuOpen = false;
      this.searchOpen = false;
      this.$scroll.release();
    },
    onMenu() {
      this.$scroll.freeze();
      this.menuOpen = true;
    },
    onSearch() {
      this.$store.commit('isFirst', false);
      this.$scroll.freeze();
      this.$scroll.scrollTo(0);
      this.$store.commit('searchMode', true);
    },
    clickClose() {
      this.$scroll.release();
      this.menuOpen = false;
    },
  },
};
</script>

<style lang="less">
@import '~@/less/proj.less';

[app-header] { .fix; .wf; z-index: 49;
  .search & { .hide; }
  &.roll.scrolled { pointer-events: none; }
  &.roll header { .t-y(-100%); }
  header { .rel; .bgc(#fff); .wf; .h(70); .t-y(0); transition: transform 0.6s ease;
    .dark & { .bgc(#000); }
    .transparent & { .bgc(transparent); }
    .blur & { .bgc(rgba(255, 255, 255, .45)); backdrop-filter: blur(4px); }
    .dark.blur & { .bgc(rgba(0, 0, 0, .45)); backdrop-filter: blur(4px); }
    .space-wrap { .rel; .space-m; }
    .inner-wrap { .rel; .p(25, 0, 15); .hf; .-box; .space-m;
      > a { .block; .wh(48, 28); .contain; .no-repeat;
        &.logo { .bg('/img/common/logo.png');
          .dark & { .bg('/img/common/logo-w.png'); }
        }
        &.back { .bg('/img/common/ico-back.svg'); .wh(28);
          .dark & { .bg('/img/common/ico-back-w.svg'); }
        }
      }
      .aside { .abs; .rt(12, 15);
        a { .rel; .wh(52); .ml(3); .contain; .no-repeat; .ib;
          &:before { .cnt; .abs; .lt; .f; .br(50%); .bgc(rgba(0, 0, 0, 0.08)); .o(0); transition: opacity .3s ease;
            .dark & { .bgc(rgba(255, 255, 255, 0.08)); }
          }
          .no-touch &:hover:before { .o(1); }
          &.search { .bg('/img/common/ico-search.svg'); .bg-s(32, 32); .bg-c; }
          &.menu { .bg('/img/common/ico-hambergur.svg'); }
        }
        .dark & a {
          &.search { .bg('/img/common/ico-search-w.svg'); }
          &.menu { .bg('/img/common/ico-hambergur-w.svg'); }
        }
      }
    }
  }
  .drawer { .abs; .lt; .wf;
    .close { .abs; .rt(10, 15); .wh(52); .no-repeat('/img/common/ico-close.svg'); .bg-s(32, 32); .bg-c; z-index: 8; .o(0); .tr-o(.4s); pointer-events: none;
      &:before { .cnt; .abs; .lt; .f; .br(50%); .bgc(rgba(0, 0, 0, 0.08)); .o(0); transition: opacity .3s ease;
        .dark & { .bgc(rgba(255, 255, 255, 0.08)); }
      }
      .no-touch &:hover:before { .o(1); }
    }
    .drawer-backdrop { .fix; .lt; .wf; .fvh; background-color: rgba(0, 0, 0, 0.6); .o(0); pointer-events: none; .tr-a(.1s); }
    .drawer-holder { .fix; .lt; .wf; .bgc(#000); .p(0, 20, 50); .-box; .c(#fff); .o(0); .t-y(-5%); pointer-events: none; .tr-a(.1s);
      .logo { .fs(17, 62); .c(#AFAFAF); }
      .drawer-menu { .mt(50);
        a { .block; .fs(48, 1.2); .c(#fff);
          &.router-link-active { .c(#fff); }
        }
        a + a { .mt(10); }
      }
    }
    &.on {
      .close { .o(1); pointer-events: auto; }
      .drawer-backdrop { .o(1); pointer-events: auto; .tr-a(.4s); }
      .drawer-holder { .l(0); .t-y(0); .o(1); pointer-events: auto; .tr-a(.4s); }
    }
  }
}
@media (min-width: @screen-tp-min) {
  [app-header] {
    .drawer .drawer-holder {
      .logo { .fs(20, 62); }
      .drawer-menu {
        a { .fs(80, 1.2); }
      }
    }
  }
}
@media (min-width: @screen-tl-min) {
  [app-header] {
    header { .h(80);
      .inner-wrap { .pt(35);
        .aside { .t(25); }
      }
    }
    .drawer .close { .t(25); }
  }
}
@media (min-width: @screen-dm-min) {
  [app-header] {
    .inner-wrap, .space-wrap { .rel; .space-d; }
  }
}
@media (min-width: @screen-dx-min) {
  [app-header] {
    .drawer .drawer-holder {
      .drawer-menu {
        a { .fs(120, 1.2); }
      }
    }
  }
}
</style>
